import { render, staticRenderFns } from "./studentStoryList.vue?vue&type=template&id=3cd7ac68"
import script from "./studentStoryList.vue?vue&type=script&lang=js"
export * from "./studentStoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports